<template>
  <div class="lead-tracker-wrapper">
    <h2 class="h2-header">Mail Resender (atm sendgrid only!)</h2>
    <v-textarea
      density="compact"
      variant="outlined"
      rounded="lg"
      single-line
      hide-details
      v-model="objectIds"
      placeholder="Email IDs (comma-separated)"
    ></v-textarea>
    <v-btn rounded="lg" class="gradient-color-primary" @click="sendObjectIds"
      >Mails senden</v-btn
    >
  </div>
</template>

<script>
import apiClient from "../../plugins/axios";

export default {
  data() {
    return {
      objectIds: "",
    };
  },
  methods: {
    async sendObjectIds() {
      try {
        const idsArray = this.objectIds.split(",").map((id) => id.trim());
        const response = await apiClient.post("/actions/mailReSender/", {
          emailIDs: idsArray,
        });

        const data = response.data;

        if (data.error) {
          alert("Fehler: " + data.error);
          console.log(data.successEmailIDs);
          throw new Error("Email senden fehlgeschlagen");
        }
        alert("Mails erfolgreich gesendet: " + data.successEmailIDs);
      } catch (error) {
        console.error(error);
        alert("Fehler beim Senden der Mails: " + error.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.lead-tracker-wrapper {
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 12px;
  border: 1px solid rgb(196, 196, 196);
  border-radius: 12px;
  background-color: white;
}
</style>

